/** Capitalise the first letter of each whitespace/underscore-separated word.
 *  FE mirror of SQL initcap() for the single lowercase tokens we use as driver /
 *  value_type fallbacks (e.g. 'media' -> 'Media', 'nsp' -> 'Nsp'). */
export function titleCase(s: string): string {
  return s
    .split(/[\s_]+/)
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
    .join(' ')
}
